import { Confirmation } from './confirmation';
import { PhoneNumber } from './phone-number';
import { Introduction } from './introduction';

export const Mfa = { Introduction, Confirmation, PhoneNumber };
